export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-950 text-background-300">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <a href="#hero" className="inline-flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-7 h-7 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-accent-400"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                爱丫爱丫影院
              </span>
            </a>
            <p className="text-xs text-background-400 leading-relaxed">
              最新电影在线观看平台，提供动作电影、喜剧电影、经典电影大全，
              免费高清不卡顿，流畅播放。每日更新片源，致力于为电影爱好者提供最优质的在线观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">快速导航</h4>
            <div className="flex flex-col space-y-2.5">
              {[
                { label: '热门推荐', href: '#cards' },
                { label: '最新快讯', href: '#updates' },
                { label: '热门话题', href: '#topics' },
                { label: '热播榜单', href: '#ranking' },
                { label: '移动观影', href: '#app' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-xs text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">电影类型</h4>
            <div className="flex flex-col space-y-2.5">
              {['动作电影', '喜剧电影', '经典电影', '科幻大片', '悬疑烧脑', '华语佳片'].map((type) => (
                <a
                  key={type}
                  href="#cards"
                  className="text-xs text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {type}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">合作伙伴</h4>
            <p className="text-xs text-background-500 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 cursor-pointer hover:text-accent-400 transition-colors duration-200">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 cursor-pointer hover:text-accent-400 transition-colors duration-200">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 cursor-pointer hover:text-accent-400 transition-colors duration-200">
                <i className="ri-bilibili-line"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500 whitespace-nowrap">
            &copy; 2026 爱丫爱丫影院. 免费高清在线观影平台.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="cursor-pointer hover:text-background-300 transition-colors duration-200 whitespace-nowrap">服务条款</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors duration-200 whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors duration-200 whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}